import React, { useEffect, useState } from 'react';
import { LeadScriptPanel } from './components/LeadScriptPanel';
import { lead } from './data/lead';
import { leadScripts } from './data/leadScripts';
import type { LeadSource } from './types/leadScript';
interface AppProps {
  leadSource?: 'servicing' | 'prospect' | 'directMail' | 'vaCashout' | 'internet' | 'cashoutProspect' | 'rateTermIrrrl' | 'newHomeListing' | 'nerdWallet';
  side?: 'left' | 'right';
  defaultExpanded?: boolean;
}
export function App({
  leadSource = 'servicing',
  side = 'right',
  defaultExpanded = true
}: AppProps) {
  const [source, setSource] = useState<LeadSource>(leadSource);
  useEffect(() => {
    setSource(leadSource);
  }, [leadSource]);
  return <div className={`flex h-screen w-full overflow-hidden bg-canvas ${side === 'right' ? 'justify-end' : 'justify-start'}`} data-id="element-0" data-mp="2whx9joashed2">
      <LeadScriptPanel key={`${side}-${defaultExpanded}`} lead={lead} scripts={leadScripts} source={source} onSourceChange={setSource} side={side} defaultExpanded={defaultExpanded} data-id="element-1" data-mp="23w4e5zrtp20b" />
    </div>;
}